<template>
  <div class="modelling-log">
    <el-collapse class="r-collapse" v-model="activeNames">
      <el-collapse-item title="История расчетов" name="1">
        <ul>
          <li>Расчет 1</li>
          <li>Расчет 2</li>
          <li>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem
            repudiandae nesciunt sequi, eveniet pariatur officia. Totam fugit
            nisi incidunt quidem.
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: []
    };
  }
};
</script>

<style lang="scss">
.modelling-log {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  border-radius: var(--border-radius);
  background-color: var(--dividers_low_contrast) !important;
  .el-collapse {
    border: none !important;
    &-item {
      font-size: 12px;
      width: 140px;
      height: 20px;
      transition: width 0.4s, height 0.4s linear;
      overflow: hidden;
      &.is-active {
        width: 250px;
        height: 300px;
      }
      &__header {
        min-height: auto !important;
        height: 20px !important;
        line-height: 20px !important;
        padding: 0 5px !important;
        border: none;
      }
      &__wrap {
        height: calc(100% - 15px);
        overflow: auto;
        border: none !important;
      }
    }
  }
}
</style>
